<style>

</style>

<template>
    <div id="present_hour_page">
        <card>
            <Form ref="searchForm" inline class="searchForm" id="searchFormSection">
                <FormItem>
                    <Button type="primary" @click="apply" size="small" style="margin-left:10px;">申请赠送课时</Button>
                </FormItem>
            </Form>
            <Table :columns="columns" :data="data" :loading="dataLoading" :stripe="true" :border="true">
                <template slot-scope="{ row, index }" slot="applyInfo">
                    <Row>
                        <Col span="12">学员：</Col>
                        <Col span="12">{{row.studentName}}</Col>
                    </Row>
                    <Row>
                        <Col span="12">课程：</Col>
                        <Col span="12">{{row.courseName}}</Col>
                    </Row>
                    <Row>
                        <Col span="12">赠送数：</Col>
                        <Col span="12">{{row.customer_date_1}}节课</Col>
                    </Row>
                    <Row>
                        <Col span="12">申请时间：</Col>
                        <Col span="12">{{row.createtime}}</Col>
                    </Row>
                    <Row>
                        <Col span="12">申请人：</Col>
                        <Col span="12">{{row.applierName}}</Col>
                    </Row>
                    <Row>
                        <Col span="12">原因：</Col>
                        <Col span="12">{{row.remark}}</Col>
                    </Row>
                </template>
                <template slot-scope="{ row, index }" slot="verifyInfo">
                    <Row>
                        <Col span="12">审核状态：</Col>
                        <Col span="12">{{row.state|stateFilter}}</Col>
                    </Row>
                    <Row>
                        <Col span="12">审核人：</Col>
                        <Col span="12">{{row.verifierName}}</Col>
                    </Row>
                    <Row>
                        <Col span="12">审核时间：</Col>
                        <Col span="12">{{row.verify_time}}</Col>
                    </Row>
                    <Row>
                        <Col span="12">审核意见：</Col>
                        <Col span="12">{{row.verify_remark}}</Col>
                    </Row>
                </template>
                <template slot-scope="{ row, index }" slot="op">
                    <Button type="primary" @click="verify(row, index)" v-if="row.state==0 && $store.state.user.isHoAdmin">审核</Button>
                </template>
            </Table>
            <Page :total="pageTotalNum" :current="pageCurrent" v-if="showPager"
                  show-elevator show-total show-sizer @on-change="changePage" :page-size="size"></Page>
        </card>
        <Modal v-model="showApply" title="申请赠送课时" width="800">
            <Form :model="applyForm" :label-width="100" ref="applyForm"
                  :rules="applyFormValidate"
                  @keyup.enter.native="applyHandleSubmit()">
                <FormItem label="学员" prop="studentId" >
                    <Select v-model="applyForm.studentId" filterable style="width: 250px" clearable>
                        <Option v-for="item in studentList" :value="item.id" :key="item.id">{{ item.name}}</Option>
                    </Select>
                </FormItem>
                <FormItem label="课程" prop="courseId" >
                    <Select v-model="applyForm.courseId" filterable style="width: 250px" clearable>
                        <Option v-for="item in courseList" :value="item.id" :key="item.id">{{ item.name}}({{ item.type | courseTypeFilter }})
                        </Option>
                    </Select>
                </FormItem>
                <FormItem label="增加课时数" prop="num" >
                    <Input v-model="applyForm.num" placeholder="" number ></Input>
                </FormItem>
                <FormItem label="申请理由" prop="reason" >
                    <Input v-model="applyForm.reason" placeholder="" ></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="applyModalCancel">取消</Button>
                <Button type="primary" size="large" @click="applyHandleSubmit()" :loading="applyForm.saving">
                    确定
                </Button>
            </div>
        </Modal>
        <Modal v-model="showVerify" title="审核" width="600">
            <Form :label-width="100" ref="verifyForm">
                <FormItem label="学员"  >
                    {{applyInfo.studentName}}
                </FormItem>
                <FormItem label="课程"  >
                    {{applyInfo.courseName}}
                </FormItem>
                <FormItem label="增加课时数" >
                    {{applyInfo.customer_date_1}}
                </FormItem>
                <FormItem label="申请理由" >
                    {{applyInfo.remark}}
                </FormItem>
                <FormItem label="审批意见"  >
                    <Input v-model="verifyForm.remark" placeholder="" ></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="verifyModalCancel">取消</Button>
                <Button type="error" size="large" @click="verifyHandleNo" :loading="verifyForm.saving1">
                    审核不通过
                </Button>
                <Button type="primary" size="large" @click="verifyHandleYes" :loading="verifyForm.saving2">
                    审核通过
                </Button>
            </div>
        </Modal>
    </div>
</template>

<script>

  export default {
    name: 'present_hour',
    components: {

    },
    data() {
      return {
        showVerify:false,
        studentList: [],
        applyInfo:{},
        columns:[
          {
            title: '校区',
            width:120,
            key: 'zoneName'
          },
          {
            title: '申请信息',
            slot: 'applyInfo'
          },
          {
            title: '审核信息',
            slot: 'verifyInfo'
          },
          {
            title: '操作',
            slot: 'op'
          },
        ],
        data:[],
        dataLoading:false,
        pageTotalNum:0,
        pageCurrent:1,
        size:10,
        showApply:false,
        applyForm:{
          studentId:null,
          courseId:null,
          num:null,
          reason:null,
          saving:false
        },
        verifyForm:{
          remark:null,
          saving1:false,
          saving2:false
        },
        applyFormValidate:{
          studentId: [
            { required: true, type: 'number',message: '请选择学员', trigger: 'blur' }
          ],
          courseId: [
            { required: true, type: 'number',message: '请选择课程', trigger: 'blur' }
          ],
          num: [
            { required: true, type: 'number',message: '请输入赠送课时数', trigger: 'blur' }
          ],
          reason: [
            { required: true, message: '请输入申请理由', trigger: 'blur' }
          ],
        }
      }
    },
    mounted() {
      this.getStudentList();
      this.getList();
    },
    methods: {
      getStudentList() {
        let param = {
          page: 1,
          size: 9999
        }
        this.$api.student.list(param).then(res => {
          if (res.state == "ok") {
            this.studentList = res.data.list;
          } else {
            this.$Message.error(res.msg)
          }
        })
      },
      getList(){
        this.dataLoading = true;
        let param = {
          page: this.pageCurrent,
          size:this.size
        }
        this.$api.task.getPresentTaskList(param).then(resp => {
          this.data = resp.data.list;
          this.pageTotalNum = resp.data.totalRow;
          this.totalPage = resp.data.totalPage;
          this.pageCurrent = resp.data.pageNumber;
          this.dataLoading = false;
        });
      },
      verify(applyInfo){
        this.applyInfo = applyInfo;
        this.verifyForm={
          remark:null,
          saving1:false,
          saving2:false
        },
        this.showVerify = true;
      },
      verifyModalCancel(){
        this.showVerify = false;
      },
      verifyHandleYes(){
        let self = this;
        self.verifyForm.saving2 = true;
        console.log(self.applyInfo);
        self.$api.task.verifyPresent({
          'id': self.applyInfo.id,
          'isAgree': true,
          'remark': self.verifyForm.remark
        }).then(resp => {
          if (resp.state == 'ok') {
            self.$Message.info({
              content: '操作成功：审核通过',
              onClose() {
                self.showVerify = false;
                self.getList();
              }
            });
          } else {
            self.verifyForm.saving2 = false;
            self.$Message.error(resp.msg);
          }
        });
      },
      verifyHandleNo(){
        let self = this;
        self.verifyForm.saving1 = true;
        self.$api.task.verifyPresent({
          'id': self.applyInfo.id,
          'isAgree': false,
          'remark': self.verifyForm.remark
        }).then(resp => {
          if (resp.state == 'ok') {
            self.$Message.info({
              content: '操作成功：拒绝申请',
              onClose() {
                self.showVerify = false;
                self.getList();
              }
            });
          } else {
            self.verifyForm.saving1 = false;
            self.$Message.error(resp.msg);
          }
        });
      },
      apply(){
        this.applyForm={
          studentId:null,
          courseId:null,
          num:null,
          reason:null,
          saving:false
        };
        this.showApply = true;
      },
      applyHandleSubmit(){
        let self = this;
        self.$refs['applyForm'].validate((valid) => {
          try{
            if (valid) {
              self.applyForm.saving = true;
              self.$api.task.applyPresent({
                'eduBizRecord.course_id':self.applyForm.courseId,
                'eduBizRecord.customer_date_1':self.applyForm.num,
                'eduBizRecord.student_id':self.applyForm.studentId,
                'eduBizRecord.remark':self.applyForm.reason
              }).then(resp => {
                self.applyForm.saving = false;
                if (resp.state == 'ok'){
                  self.$Message.info({
                    content:'申请成功，等待审核',
                    onClose (){
                      self.showApply = false;
                      self.getList();
                    }
                  });
                }else{
                  self.$Message.error(resp.msg);
                }
              });
            } else {
              self.$Message.error('表单校验不通过');
            }
          }catch(err){
            console.log(err);
          }

        })
      },
      applyModalCancel(){
        this.showApply = false;
      },
      pageSizeChange(pageSize){
        this.size=pageSize;
        this.getList();
      },
      changePage(page){
        this.pageCurrent = page;
        this.getList();
      },
      onCloseForm(){
        this.getList();
      }
    },
    filters: {
      courseTypeFilter: function (value) {
        if (value == 1) {
          return '一对一';
        } else if (value == 2) {
          return '班课';
        } else {
          return '未知:' + value
        }
      },
      stateFilter:function(state){
        if (state == 0){
          return '申请中';
        }else if (state == 1){
          return '审核通过';
        }else if (state == 2){
          return '被拒绝';
        }
      }
    },
    computed: {
      showPager: function () {
        return this.totalPage > 1
      },
      courseList() {
        return this.$store.state.app.courseList
      },
    }
  }
</script>


